export default "__VITE_ASSET__Dheh3XaF__"